module.exports = __webpack_public_path__ + "static/media/_MIC2309.thumbnail.fe97173b.png";